const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/$.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/$")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});